import { render } from "./pb-slider.vue?vue&type=template&id=43bbd0fe"
import script from "./pb-slider.vue?vue&type=script&lang=js"
export * from "./pb-slider.vue?vue&type=script&lang=js"

import "./pb-slider.vue?vue&type=style&index=0&id=43bbd0fe&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__